export default __webpack_public_path__ + "static/media/padel-firstServe-logo.a766c265.png";